import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	overrideWith: {
		id: 'eoc-schedule.common.ui.shift-card.overridden-with.override-with',
		defaultMessage: 'Override with',
		description: 'Label for overridden with.',
	},
});
